// extracted by mini-css-extract-plugin
export default {"area":"area--tFnHs"};